<svg class="{{legendPosition}}" id="svg-container" viewBox="-32 -32 64 64" width="100%" height="90%"  style="max-height:300px"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:dc="http://purl.org/dc/elements/1.1/"
	version="1.1">
	{{#each piePieces}}
	<circle r="{{radius}}" cx="0" cy="0" stroke-width="{{strokeWidth}}" stroke-dasharray="{{filledShare}} {{emptyShare}}"  transform="rotate({{angle}})"
		stroke="{{color}}"
		fill="none"
	></circle>
	{{/each}}
	{{#if centerText}}
		<text x="0" y="0" text-anchor="middle" font-size="6" alignment-baseline="central"
			stroke="white" stroke-width="0.5em" fill="black" paint-order="stroke" stroke-linejoin="round">{{centerText}}</text>
	{{/if}}
</svg>
{{#if showLegend}}
	<div class="legend {{legendPosition}}">
	{{#each piePieces}}
		<i class="fa fa-square " style="color:{{color}};" ></i> <span class="value-name">{{name}}</span> <span>{{displayValue}}</span>
	{{/each}}
	</div>
{{/if}}
